import { Grid } from '@mui/material';
import { PaymentViewProps } from 'pages/digitalRetailing/DigitalRetailingInterface';
import { formatWithCommaSeparator } from 'pages/tradeIn/TradeInUtils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CommonButton } from 'sharedComponents/index';
import { RootState } from 'store/store';

const AllPaymentView: React.FC<PaymentViewProps> = ({ navigateToTab }) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const termWatcher = watch('term');

  const downPaymentWatcher = watch('downPayment');

  const { authenticateClientData } = useSelector((state: RootState) => state.auth);
  const { vehicleData, paymentData } = useSelector((state: RootState) => state.digitalRetailingStore);

  const term = authenticateClientData?.data?.widgetData?.term;
  const apr = authenticateClientData?.data?.widgetData?.apr;

  const onNavigateToTab = (index: number) => {
    navigateToTab(
      {
        downpayment: downPaymentWatcher,
        term,
        apr,
        financed: vehicleData?.MSR,
        monthly: paymentData?.monthly,
      },
      index
    );
  };

  return (
    <>
      {vehicleData ? (
        <Grid container spacing={2} marginBottom={2}>
          <Grid item md={6}>
            <div className='dr-payment-tile'>
              <CommonButton label={t('Submit')} onClick={() => onNavigateToTab(1)} className='dr-payment-tile__btn' />
              <div className='dr-payment-tile__cat text-secondary text-uppercase fw-500 mb-3'>Cash</div>
              <div className='dr-payment-tile__amt-pay mb-3'>
                <span className='dr-payment-tile__amt fw-500'>{`$${formatWithCommaSeparator(vehicleData?.MSR)}`}</span>
                <span className='dr-payment-tile__amt-pay-lbl text-secondary'>at signing</span>
              </div>
              <div className='dr-payment-tile__ms-grid one-col'>
                <div className='dr-payment-tile__vwl one-line'>
                  <div className='dr-payment-tile__vwl__lbl'>MSRP</div>
                  <div className='dr-payment-tile__vwl__value'>{`$${formatWithCommaSeparator(vehicleData?.MSR)}`}</div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      ) : null}

      <Grid container spacing={2}>
        {paymentData?.monthly ? (
          <Grid item md={6}>
            <div className='dr-payment-tile'>
              <CommonButton label={t('Submit')} onClick={() => onNavigateToTab(2)} className='dr-payment-tile__btn' />
              <div className='dr-payment-tile__cat text-secondary text-uppercase fw-500 mb-3'>Finance</div>
              <div className='dr-payment-tile__amt-pay mb-3'>
                <span className='dr-payment-tile__amt fw-500'>{`$${formatWithCommaSeparator(
                  paymentData?.monthly?.toFixed(2)
                )}`}</span>
                <span className='dr-payment-tile__amt-pay-lbl text-secondary'>{`X ${termWatcher || term} months`}</span>
              </div>
              <div className='dr-payment-tile__ms-grid two-col'>
                <div className='dr-payment-tile__vwl text-center'>
                  <div className='dr-payment-tile__vwl__lbl'>APR</div>
                  <div className='dr-payment-tile__vwl__value'>{`${apr}%`}</div>
                </div>
                {downPaymentWatcher ? (
                  <div className='dr-payment-tile__vwl text-center'>
                    <div className='dr-payment-tile__vwl__lbl'>Signing Cash</div>
                    <div className='dr-payment-tile__vwl__value'>{`$${formatWithCommaSeparator(
                      downPaymentWatcher
                    )}`}</div>
                  </div>
                ) : null}
              </div>
            </div>
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};

export default AllPaymentView;
